module.exports = __webpack_public_path__ + "img/brand.9b2224fc.png";